import {OfficeLookupResponse} from '@frontend/shared';

export interface CompanyEmployeeContainer {
  office: OfficeLookupResponse;
  salariedHeadcount: number;
  industrialHeadcount: number;
  contingentHeadcount: number;
  totalHeadcount: number;
  totalFte: number;
}

export type CompanyEmployeeSummaryData = Omit<CompanyEmployeeContainer, 'office'>;

export const NUMERIC_FIELDS = [
  'salariedHeadcount',
  'industrialHeadcount',
  'contingentHeadcount',
  'totalHeadcount',
  'totalFte',
] as const;
